import React from 'react';
import { DropDown } from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';

const ActionsDropdownWrapper = ({ children, testId }) => {

  return (
    <div
      onMouseUp={(e) => e.stopPropagation()}
      data-testid={testId}
    >
      <DropDown
        header="Actions"
        hideOnSelection
        expandOnClick
        className="mobile-list-dropdown mobile-list-dropdown--header"
      >
        {children}
      </DropDown>
    </div>
  );
};

export default ActionsDropdownWrapper;

ActionsDropdownWrapper.propTypes = {

  /** children: jsx nodes of DropDownItems */
  children: PropTypes.arrayOf(PropTypes.node).isRequired,

  /** testId: needed for automation testing */
  testId: PropTypes.string
};

ActionsDropdownWrapper.defaultProps = {
  testId: 'action-dropdown'
};
